import React, { useEffect } from 'react';

import {
  ContainerChat,
  ProfileInternalChat,
  AvatarWrapper,
  StatusIndicator,
  UserList,
  ButtonAddGroup,
  Sinalization,
  GroupOptionsButton,
  CardNotificationBadge
} from '../../style';

import LogoG4 from '../../../../assets/img/theme/iconG4.png';
import { BsThreeDotsVertical } from 'react-icons/bs';

export function UserListContainer({
  sizeChat,
  handleInfosUserFunction,
  handleOpenGroupChat,
  updateConversation,
  users,
  usersStatus = {},
  userConversation,
  senders,
  unreadFromUsers,
  unreadGroups,
  search
}) {
  const [chats, setChats] = React.useState([]);
  const loginUser = localStorage.getItem('login');
  const originUrl = window.location.origin.includes('localhost')
    ? process.env.REACT_APP_PROXY_URL
    : window.location.origin + '/';

  const statusColorMap = {
    available: '#21c25e',
    busy: '#e53935',
    away: '#9e9e9e'
  };

  const matchesSearch = (name, query) => {
    if (!query) return true;

    const normalize = (value) =>
      value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();

    const normalizedName = normalize(name);
    const normalizedQuery = normalize(query);

    return normalizedName.includes(normalizedQuery);
  };

  const makeDataToList = () => {
    const map = new Map();
    const userMap = new Map(users.map((user) => [user.login, user]));

    userConversation
      .filter((conversation) =>
        matchesSearch(conversation?.name ?? conversation.sender, search)
      )
      .forEach((chat) => {
        if (chat.type === 'group') {
          map.set(chat.id, {
            title: chat.name,
            ...chat,
            withNewMessage: unreadGroups?.includes(chat.id)
          });
        } else {
          const user = userMap.get(chat.sender);
          map.set(chat.sender, {
            title: user?.name || chat.sender,
            name: user?.name || chat.sender,
            ...chat,
            login: chat.sender,
            withNewMessage: unreadFromUsers?.includes(chat.sender),
            isLogged: user?.isLogged
          });
        }
      });

    users
      .filter(
        (user) =>
          matchesSearch(user.name, search) &&
          user.login !== loginUser &&
          !senders.includes(user.login)
      )
      .forEach((user) => {
        const inList = map.has(user.login);

        if (!inList) {
          map.set(user.login, {
            title: user.name,
            name: user.name,
            type: 'not_started',
            ...user,
            withNewMessage: unreadFromUsers?.includes(user.login)
          });
        }
      });

    setChats(
      Array.from(map.values()).sort((a, b) => {
        if (b.withNewMessage && !a.withNewMessage) return 1;
        if (a?.lastMessage?.createdAt && !b?.lastMessage?.createdAt) return -1;
        const dateA = new Date(a?.lastMessage?.createdAt || 0);
        const dateB = new Date(b?.lastMessage?.createdAt || 0);
        return dateB - dateA;
      })
    );
  };

  useEffect(() => {
    makeDataToList();
  }, [userConversation, users, search, senders, unreadGroups, unreadFromUsers]);

  return (
    <ContainerChat sizeChat={sizeChat}>
      {chats.map((chat) => {
        if (chat.type === 'group') {
          return (
            <UserList key={chat.id} onClick={() => handleOpenGroupChat(chat)}>
              <ProfileInternalChat
                src={chat.picture ? originUrl + chat.picture : LogoG4}
                alt="Group picture"
              />
              <div className="name-user-chat-internal">
                <label className="title_internal_chat">{chat.title}</label>
                <label className="lastMessage">
                  {chat?.lastMessage ? chat?.lastMessage?.content : ''}
                </label>
              </div>
              {chat?.withNewMessage && (
                <CardNotificationBadge>
                  {chat.newMessagesCount}
                </CardNotificationBadge>
              )}
              <GroupOptionsButton
                title="Opções do grupo"
                onClick={(e) => {
                  e.stopPropagation();
                  window.dispatchEvent(
                    new CustomEvent('internalchat:group:options', {
                      detail: {
                        groupId: chat.id,
                        group: chat
                      }
                    })
                  );
                }}
              >
                <BsThreeDotsVertical size={18} />
              </GroupOptionsButton>
            </UserList>
          );
        }

        if (chat.type === 'private') {
          const userStatus = usersStatus[chat.login] || 'away';
          const statusColor = statusColorMap[userStatus] || statusColorMap.away;

          return (
            <UserList
              key={chat.login}
              onClick={() => {
                handleInfosUserFunction(chat);
                updateConversation(chat);
              }}
            >
              <AvatarWrapper>
                {chat.profile_pic ? (
                  <ProfileInternalChat
                    src={originUrl + chat.profile_pic}
                    alt="Profile picture"
                  />
                ) : (
                  <ProfileInternalChat src={LogoG4} alt="Profile picture" />
                )}
                <StatusIndicator color={statusColor} />
              </AvatarWrapper>

              <div className="name-user-chat-internal">
                <label className="title_internal_chat">{chat.title}</label>
                <label className="lastMessage">
                  {chat?.lastMessage ? chat?.lastMessage?.content : ''}
                </label>
              </div>

              {chat.withNewMessage && (
                <CardNotificationBadge>
                  {chat.newMessagesCount}
                </CardNotificationBadge>
              )}
            </UserList>
          );
        }

        if (chat.type === 'not_started') {
          const userStatus = usersStatus[chat.login] || 'away';
          const statusColor = statusColorMap[userStatus] || statusColorMap.away;

          return (
            <UserList
              key={chat.login}
              onClick={() => {
                handleInfosUserFunction(chat);
                updateConversation(chat);
              }}
            >
              <AvatarWrapper>
                {chat.profile_pic ? (
                  <ProfileInternalChat
                    src={originUrl + chat.profile_pic}
                    alt="Profile picture"
                  />
                ) : (
                  <ProfileInternalChat src={LogoG4} alt="Profile picture" />
                )}
                <StatusIndicator color={statusColor} />
              </AvatarWrapper>

              <div className="name-user-chat-internal">
                <label className="title_internal_chat">{chat.title}</label>
                <label className="lastMessage">
                  {chat?.lastMessage ? chat?.lastMessage?.content : ''}
                </label>
              </div>

              {chat.withNewMessage && <Sinalization color="#c91c7f" />}
            </UserList>
          );
        }
      })}
    </ContainerChat>
  );
}
